import { render, staticRenderFns } from "./ProjectServiceTab.vue?vue&type=template&id=2778006f"
import script from "./ProjectServiceTab.vue?vue&type=script&lang=ts"
export * from "./ProjectServiceTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports